const firebaseConfig = {
    development: {
        apiKey: 'AIzaSyBOR-jvJGO75Lxu7F1_nMQayWQwDuZKo8k',
        authDomain: 'omyfu-ngin-dev.firebaseapp.com',
        databaseURL: 'https://omyfu-ngin-dev.firebaseio.com',
        projectId: 'omyfu-ngin-dev',
        storageBucket: 'omyfu-ngin-dev.appspot.com',
        messagingSenderId: '137869022515'
    },
    staging: {
        apiKey: 'AIzaSyAhN7lSpmSMu0TvT7eWqWL0ORU8-zWIAiY',
        authDomain: 'omyfu-ngin-staging.firebaseapp.com',
        databaseURL: 'https://omyfu-ngin-staging.firebaseio.com',
        projectId: 'omyfu-ngin-staging',
        storageBucket: 'omyfu-ngin-staging.appspot.com',
        messagingSenderId: '591610368704'
    },
    production: {
        apiKey: 'AIzaSyDqFcrYNrr5jWlElSaG6CUR8AnGvDz7ATA',
        authDomain: 'omyfu-ngin.firebaseapp.com',
        databaseURL: 'https://omyfu-ngin.firebaseio.com',
        projectId: 'omyfu-ngin',
        storageBucket: 'omyfu-ngin.appspot.com',
        messagingSenderId: '785127720082'
    }
}

export default firebaseConfig



// WEBPACK FOOTER //
// ./src/config/firebase/config.js